
import { defineComponent } from "vue";

export default defineComponent({
  name: "InfoBlock",

  props: {
    text: String,
  },
});
